export default {
    evt : [
        {
            tag : '活动时间：',
            text : '3月19日-4月15日，共4周，购买和兑换截止4月17日。',
        },
        {
            tag : '获取经验：',
            text : '参与娱乐*三国无双/天命*荆州争霸/英霸官渡/英霸*天命无双/军团出征/军团出征*巅峰地图，每局活动结束后所获得的军威值将1:1转化为经验值，天命*荆州争霸地图额外获得20%经验值。',
        },
        {
            tag : '鸡王奖励：',
            text : '【普通奖励】为免费解锁，【通行证奖励】需付费解锁，经验值到达对应等级后，即可领取相应奖励。',
        },
        {
            tag : '争霸排名：',
            text : '本次活动增加个人经验值排行榜，经验值无上限，活动结束后根据排名发放奖励。',
        },
        {
            tag : '争霸商店：',
            text : '活动奖励中领取的【金鸡币】可在争霸商店里兑换商品。每期获得的【金鸡币】活动结束后会清空，请及时使用。',
        },
        {
            tag : '邀请有礼：',
            text : '玩家可邀请好友进行绑定，完成指定任务即可领取奖励。',
        },                          
    ],
    invite : [
        {
            text : '活动期间，每名玩家最多邀请 3名 玩家接受自己的邀请绑定，但最多接受1人邀请绑定。邀请其他人和自己绑定后，自己可领取1份【争霸相遇礼】，每人最多领取3份。',
        },
        {
            text : '被邀请的玩家（每位玩家单独计算）到达1000经验时，自己可领取1份【争霸活跃礼】，每人最多领取3份。',
        },
        {
            text : '邀请的玩家和本人均购买任意通行证，即可领取1份【争霸慷慨礼】，每人最多领取3次。',
        },                              
    ],
    shop : [],
}